import { PSY_HOURLY_SLOTS, NFB_WEEKDAY_SLOTS, NFB_SATURDAY_SLOTS, SATURDAY_WEEKDAY } from "../constants";

export const PSY_DURATION_ROWS = 4;
export const NFB_DURATION_ROWS = 3;
export const GRID_STEP_MINUTES = 15;

// Grid-private colour palette (used only inside grid/). Single green for every bookable / free spot
// (empty available slot + NFB-with-spare-capacity), so there is one "you can book here" colour.
export const LIGHT_GREY = "#f5f5f5";
export const FREE_GREEN = "#c8e6c9";
export const FREE_TEXT_GREEN = "#2e7d32";
export const TIME_OFF_PINK = "#ffebee";
export const PSY_RESERVATION_BLUE = "#bbdefb";
export const PSY_BOOKING_ONLY_BG = "#e1bee5";
export const NFB_FULL_BG = "#ef9a9a";
export const NFB_BLOCKED_GREY = "#e0e0e0";
export const BLOCKED_TEXT_GREY = "#616161";
// Darker, more saturated than a pale orange so the NFB block edge reads against red/green/grey.
export const NFB_BORDER = "#d84315";
// Session-only (yellow): NFB reservations are full, but a device is still physically free on the date.
export const NFB_SESSION_ONLY_BG = "#ffe082";
export const NFB_SESSION_ONLY_TEXT = "#f57f17";

export const getTimeMinusMinutes = (time: string, minutesToSubtract: number) => {
    const [hours, minutes] = time.split(":").map(Number);
    const totalMinutes = hours * 60 + minutes - minutesToSubtract;
    const newHours = Math.floor(totalMinutes / 60);
    const newMinutes = totalMinutes % 60;
    return `${String(newHours).padStart(2, "0")}:${String(newMinutes).padStart(2, "0")}`;
};

export const isPsyStartTime = (time: string) => PSY_HOURLY_SLOTS.includes(time);

export const isNfbStartTime = (time: string, weekDay: number) => {
    const isSaturday = weekDay === SATURDAY_WEEKDAY;
    const validSlots = isSaturday ? NFB_SATURDAY_SLOTS : NFB_WEEKDAY_SLOTS;
    return validSlots.includes(time);
};

export const getBackgroundColor = (availabilityStatus: "available" | "time_off" | null) => {
    if (availabilityStatus === "available") return FREE_GREEN;
    if (availabilityStatus === "time_off") return TIME_OFF_PINK;
    return LIGHT_GREY;
};

export type NfbBlockStatus = "blocked" | "full" | "sessionOnly" | "free";

// What can be booked in an NFB slot. Reservations and the date's sessions are two independent axes
// against the same device capacity: "free" = a reservation lane is open (reservations < capacity → book
// a reservation); "sessionOnly" = reservations fill capacity but a device is still free that date (book a
// one-off session only); "full" = every device used that date (sessions >= capacity → book nothing);
// "blocked" = window closed. A one-off session never consumes a reservation lane, so it only drives "full".
export const getNfbBlockStatus = (capacity: number, reservationCount: number, sessionsBooked: number) => {
    if (capacity === 0) return "blocked";
    if (sessionsBooked >= capacity) return "full";
    if (reservationCount >= capacity) return "sessionOnly";
    return "free";
};

